import React from 'react'
import ReactDOM from 'react-dom'
import './scss/main.scss'
import './index.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'
import './i18n'
import 'globalInterceptor'

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// When a new version is installed and waiting, notify the app so it can prompt the
// user to reload (handled by VersionVerif). See src/VersionVerif.tsx.
serviceWorker.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('swUpdateReady', { detail: registration }))
  },
})
